import { Nullish } from '~/@types/generic'
import type { Variant } from '~/@types/product'
import { productVariantMetafields } from '~/lib/shopify/constants/metafields'
import { metafieldsToObject } from '~/lib/shopify/utils/metafield-to-object'

import { UnlikelyVariant } from '@unlikelystudio/commerce-connector'

export default function serializeVariant(
  variant: UnlikelyVariant,
): Nullish<Variant> {
  const {
    disablesEngraving,
    isSubtitleEngraving,
    atelierDate,
    defaultCustomizationTitle,
    isBundleProductPreOrder,
    disablesLabel,
    isSubtitleLabel,
    isTitleLabel,
    legendCharlength,
    enablesSaucer,
  } = metafieldsToObject(variant?.metafields, productVariantMetafields)

  const hasAtelierDate = atelierDate ?? null

  if (hasAtelierDate) {
    const atelierDateTimestamp = Math.floor(Date.parse(hasAtelierDate)) / 1000
    const nowDateTimestamp = Math.floor(Date.now() / 1000)

    if (nowDateTimestamp > atelierDateTimestamp) {
      return null
    }
  }

  return {
    id: variant?.id ?? null,
    title: variant?.title ?? null,
    sku: variant?.sku ?? null,
    compareAtPrice: variant?.compareAtPrice ?? null,
    price: variant?.price ?? null,
    selectedOptions: variant?.selectedOptions ?? null,
    availableForSale: variant?.availableForSale ?? false,
    image: {
      alt: variant?.title ?? null,
      src: variant?.image?.url ?? null,
      width: variant?.image?.width ?? null,
      height: variant?.image?.height ?? null,
    },
    // metafields based properties
    disablesEngraving: disablesEngraving === 'true',
    isEngravingWithSubtitle: isSubtitleEngraving === 'true',
    defaultCustomizationTitle:
      defaultCustomizationTitle?.length > 0 ? defaultCustomizationTitle : null,
    isLabelWithSubtitle:
      isSubtitleLabel === undefined ? true : isSubtitleLabel === 'true',
    isLabelWithTitle:
      isTitleLabel === undefined ? true : isTitleLabel === 'true',
    isBundleProductPreOrder: isBundleProductPreOrder === 'true',
    disablesLabel: disablesLabel === 'true',
    disablesSaucer: enablesSaucer !== 'true',
    charLength: Number(legendCharlength) ?? null,
    atelierDate: atelierDate ?? null,
  }
}
